<template>
  <div>
    <h2>
      Aguinaldos
    </h2>
    <el-card class="box-card">
      <div slot="header" class="d-flex space-between">
        <h4>Filtros</h4>
        <el-button size="mini" plain @click="showFilters = !showFilters">
          <i v-if="!showFilters" class="icon el-icon-arrow-down "></i>
          <i v-if="showFilters" class="icon el-icon-arrow-up "></i>
        </el-button>
      </div>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="6">
          <h5>Compañía</h5>
          <el-select :disabled="disableFilter" v-model="filters.company_id" placeholder="Selecciona una compañia" style="width: 100%;"
                     @change="getCompanyRelatedData()">
            <el-option
              v-for="item in companies"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="6">
          <h5>Centro de costo</h5>
          <el-select :disabled="disableFilter" v-model="filters.cost_centers_id" placeholder="Selecciona un centro de costo" style="width: 100%;"
                     multiple @change="getEmployeesData()">
            <el-option
              v-for="item in cost_centers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="6">
          <h5>Empleado</h5>
          <el-select :disabled="disableFilter" v-model="filters.employee_id" placeholder="Selecciona un empleado" style="width: 100%;"
                     multiple>
            <el-option
              v-for="item in employees"
              :key="item.id"
              :label="item.names +' '+ item.last_names"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="6">
          <h5>Periodo</h5>
          <el-select :disabled="disableFilter" v-model="filters.periods" placeholder="Selecciona un Periodo" style="width: 100%;">
            <el-option
              v-for="item in periods"
              :key="item.year"
              :label="item.label"
              :value="item.year">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="showFilters">
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :md="24">
          <el-button type="danger" @click="cleanFilters()" :loading="loading" plain>Borrar Filtros</el-button>
          <el-button type="primary" @click="disableFilters()" :loading="loading" plain>Calcular Aguinaldos</el-button>
          <el-button type="success" @click="confirmBonus()" :loading="loading" plain>Confirmar Aguinaldos</el-button>
          <el-button type="info" @click="exportReport()" :loading="loading || exporting" plain>Descargar Excel</el-button>
        </el-col>
        <el-col :md="24">
          <el-dialog title="Detalle Aguinaldo" :visible.sync="dialogFormVisible" append-to-body>
            <el-row v-if="scope">
              <el-col :md="6"><p>Nombre:</p></el-col>
              <el-col :md="6"><p>{{scope.employee.names + " " + scope.employee.last_names}}</p></el-col>
              <el-col :md="6"><p>Compañía:</p></el-col>
              <el-col :md="6"><p>{{scope.company.name}}</p></el-col>
            </el-row>
            <el-row v-if="scope">
              <el-col :md="6"><p>Cod Empleado:</p></el-col>
              <el-col :md="6"><p>{{scope.employee.employee_code}}</p></el-col>
              <el-col :md="6"><p>Centro de costos:</p></el-col>
              <el-col :md="6"><p>{{scope.cost_center.name}}</p></el-col>
            </el-row>
            <el-row v-if="scope">
              <el-col :md="6"><p>Cédula:</p></el-col>
              <el-col :md="6"><p>{{scope.employee.card}}</p></el-col>
              <el-col :md="6"><p>Periodo:</p></el-col>
              <el-col :md="6"><p>01/12/2019 - 30/11/2020</p></el-col>
            </el-row>
            <br>
              <el-table v-loading="loading" :data="bonusesData">
                <el-table-column prop="month"
                           label="Mes">
                </el-table-column>
                <el-table-column prop="total"
                           label="Salario">
                </el-table-column>
              </el-table>
            <span slot="footer" class="dialog-footer">
    <el-button @click="clearContractForm()">Cancelar</el-button>
    <el-button type="primary" @click="confirmBonus()">Confirmar</el-button>
  </span>
          </el-dialog>
        </el-col>
      </el-row>
    </el-card>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="employee.employee_code"
          label="Cod">
        </el-table-column>
        <el-table-column
          prop="employee.card"
          label="Identidad">
        </el-table-column>
        <el-table-column
          prop="employee.names"
          label="Nombre">
          <template slot-scope="scope">
            <p>{{scope.row.employee.names +' '+scope.row.employee.last_names}}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="company.name"
          label="Compañía">
        </el-table-column>
        <el-table-column
          prop="cost_center.name"
          label="Centro de costos">
        </el-table-column>
        <el-table-column
          prop="total"
          label="Total Aguinaldo">
<!--          <template slot-scope="scope">-->
<!--            <p>{{Math.round(scope.row.total)}}</p>-->
<!--          </template>-->
        </el-table-column>
        <el-table-column
          :width ="100"
          label="Acciones">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="showBonusesDialog(scope)">
              <i class="el-icon-view"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>
  </div>

</template>
<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'
  import PictureInput from 'vue-picture-input'
  import AwesomeMask from 'awesome-mask'
  import {Converter, params, parseError} from '../../packages/Helpers'
  import {saveAs} from 'file-saver'

  export default {
    extends: BaseCrud,
    name: 'employee-list',
    directives: {
      'mask': AwesomeMask
    },
    components: {
      AppTable,
      PictureInput
    },
    data () {
      return {
        params: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        disableFilter: false,
        scope: null,
        bonusesData: [],
        excelBonusesData: null,
        cost_centers: [],
        companies: [],
        payrolls: [],
        bonuses: [],
        employees: [],
        periods: [],
        months: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Setiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ],
        filters: {
          periods: (new Date().getFullYear()),
          cost_centers_id: [],
          company_id: [],
          employee_id: []
        },
        dialogFormVisible: false,
        exporting: false,
        showFilters: true,
        methodForUpdate: 'post',
        baseUrl: baseApi + '/bonuses',
        banksUrl: baseApi + '/banks',
        civilUrl: baseApi + '/civilstatus/getlist',
        companyUrl: baseApi + '/companies',
        payrollsUrl: baseApi + '/payrolls',
        bonusesUrl: baseApi + '/bonuses',
        bonusesExcelUrl: baseApi + '/bonusesExcel',
        costCentersUrl: baseApi + '/cost-centers',
        basePermission: 'employees',
        employeesURL: baseApi + '/employees',
        bonusesDetailsURL: baseApi + '/bonusesDetails'
      }
    },
    methods: {
      clearContractForm () {
        this.$refs.contractForm.resetFields()
        this.dialogFormVisible = false
        this.form.contract_ended = false
        this.form.date_ended = null
      },
      companyData () {
        this.$http.get(this.companyUrl)
          .then(
            (res) => {
              this.companies = res.body
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
      },
      getCompanyRelatedData () {
        if (this.filters.company_id) {
          this.filters.cost_centers_id = []
          delete this.filters.payroll_id
          this.$http.get(this.payrollsUrl + '?company_id=' + this.filters.company_id)
            .then(
              (res) => {
                this.payrolls = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )

          this.$http.get(this.costCentersUrl + '?company_id=' + this.filters.company_id)
            .then(
              (res) => {
                this.cost_centers = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )
          this.getEmployeesData()
        }
      },
      getEmployeesData () {
        if (this.filters.company_id > 0 && this.filters.cost_centers_id.length > 0) {
          const param = {
            pagination: 0,
            company_id: this.filters.company_id,
            cost_centers: this.filters.cost_centers_id
          }
          this.$http.get(this.employeesURL + params(param))
            .then(
              (res) => {
                this.employees = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )
        }
      },
      cleanFilters () {
        this.disableFilter = false
        this.filters = {
          periods: (new Date().getFullYear()),
          cost_centers_id: [],
          company_id: null,
          employee_id: []
        }
        this.refreshData()
      },
      disableFilters () {
        this.disableFilter = true
        this.refreshData()
      },
      getPeriods () {
        let year1 = new Date().getFullYear()
        const year2 = (year1 - 1).toString()
        const year3 = (year1 - 2).toString()

        this.periods = [
          {
            year: year1,
            label: `${year2} - ${year1}`
          },
          {
            year: year2,
            label: `${year3} - ${year2}`
          }
        ]
      },
      exportReport () {
        const data = {
          employee_id: this.filters.employee_id,
          cost_center_id: this.filters.cost_centers_id,
          company_id: this.filters.company_id,
          periods: this.filters.periods
        }
        let url = baseApi + '/reports/bonusesExcel'
        this.exporting = true
        this.$http.post(url, data, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              let filename = 'Aguinaldos'
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },

      confirmBonus () {
        this.$confirm('Esta seguro que desea confirmar aguilando(s)', '¿Confirmar aguinaldo(s)?', {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        })
        .then(() => this.storeData())
        .catch(() =>
          this.$message({ type: 'info', message: 'Confirmación de aguinaldo(s) cancelada...' })
        )
      },

      storeData () {
        let filters = {
          employee_id: this.filters.employee_id,
          cost_center_id: this.filters.cost_centers_id,
          company_id: this.filters.company_id,
          year: this.filters.periods
        }

        if (this.dialogFormVisible) {
          filters.employee_id = [this.scope.employee_id]
          filters.cost_center_id = [this.scope.cost_center_id]
          filters.company_id = this.scope.company_id
        }

        this.$http.post(this.baseUrl, filters)
          .then(
            () => {
              this.refreshData()
              if (this.dialogFormVisible) {
                this.scope = null
                this.dialogFormVisible = false
              }
            },
            (res) => {
              this.showErrors(res)
            }
          )
      },
      _beforeSend (value) {
        return Converter.objectToFormData(value)
      },
      showBonusesDialog (scope) {
        let period1 = ''
        let period2 = ''
        const yearSelected = Number(this.filters.periods)
        period1 = (yearSelected - 1) + '-12-01'
        period2 = yearSelected + '-11-30'

        const param = {
          pagination: 0,
          employee_id: scope.row.employee_id,
          period1: period1,
          period2: period2,
          company: scope.row.company_id
        }
        this.bonusesData = []
        this.$http.get(this.bonusesDetailsURL + params(param))
          .then(
            (res) => {
              for (let key of res.body) {
                key.month = this.months[key.month - 1]
                key.month += ' ' + key.year
              }
              this.bonusesData = res.body
              console.log(this.bonusesData)
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
        this.scope = scope.row

        this.dialogFormVisible = true
      },
      _beforeRefresh (params) {
        params.employee_id = this.filters.employee_id
        params.cost_center_id = this.filters.cost_centers_id
        params.company_id = this.filters.company_id
        params.year = this.filters.periods
      }
    },
    mounted () {
      this.companyData()
      this.getPeriods()
    }
  }
</script>
<style>
  .float-left {
    float: right;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/bonuses/bonuses.vue